<mbs-card
  class="mb-3 h-auto"
  [customClasses]="'bg-light border-radius-xl-important h-auto'"
  [hasPadding]="false"
  [innerBordered]="false"
  [size]="size.xs">
  <mbs-card-group class="w-100 p-3">
    <div class="h5 fw-bold mb-1">{{ 'wizards:generic.restoreFrom' | i18next }}</div>
    <mbs-button
      [isCtrl]="true"
      (click)="selectComputerClickHandler()">
      {{ fromComputer()?.name || ('shared:generic.selectComputer' | i18next) }}
    </mbs-button>
  </mbs-card-group>
  <mbs-card-group class="w-100 p-3">
    <div class="h5 fw-bold mb-1">{{ 'shared:generic.restoreTo' | i18next }}</div>
    <mbs-form-group class="mb-0">
      <ng-template #cantQRTooltip>
        <span [innerHTML]="'shared:generic.quickRestorePermission' | i18next"></span>
      </ng-template>
      <div
        class="mb-2"
        [placement]="['top-start', 'top-left']"
        [disableTooltip]="canQuickRestore()"
        [ngbTooltip]="cantQRTooltip">
        <mbs-radio
          name="restoreTo"
          [ngModel]="restoreTo()"
          (ngModelChange)="restoreTo.set($event)"
          [descriptionClasses]="'mt-0'"
          [descriptionOutside]="false"
          [disabledSelf]="!canQuickRestore()"
          [id]="'restore-to-current-radio'"
          [label]="'shared:generic.currentComputer' | i18next"
          [value]="restoreToVariants.current">
          <ng-template radioDescription>
            <span class="text-xs text-gray-600">
              {{ 'shared:generic.currentComputerInfo' | i18next }}
            </span>
          </ng-template>
        </mbs-radio>
      </div>
      <mbs-radio
        name="restoreTo"
        [ngModel]="restoreTo()"
        (ngModelChange)="restoreTo.set($event)"
        [descriptionOutside]="false"
        [disabledSelf]="!isOnline()"
        [id]="'restore-to-original-radio'"
        [label]="fromComputerLabel()"
        [value]="restoreToVariants.original">
        <ng-template
          radioDescription
          [hide]="!fromComputer() || isOnline()">
          <span class="text-xs text-gray-500">{{ 'shared:generic.isOffline' | i18next: { computer: fromComputer()?.name } }}</span>
        </ng-template>
      </mbs-radio>

      <mbs-radio
        name="restoreTo"
        [ngModel]="restoreTo()"
        (ngModelChange)="differentSelectClickHandler($event)"
        [disabledSelf]="!canRestoreTo() || !fromComputer()"
        [descriptionOutside]="false"
        [id]="'restore-to-different-radio'"
        [label]="restoreToDiffLabel"
        [value]="restoreToVariants.different">
        <ng-template #restoreToDiffLabel>
          <div class="d-flex flex-column">
            {{ 'shared:generic.differentComputer' | i18next }}
            @if (canRestoreTo() && !fromComputer()) {
              <span class="text-xs text-gray-500"> ({{ 'wizards:generic.supportedWithAgentVersion' | i18next }}) </span>
            }
          </div>
        </ng-template>
        <ng-template radioDescription>
          @if (canRestoreTo()) {
            <mbs-button
              [disabled]="restoreTo() !== restoreToVariants.different"
              [isCtrl]="true"
              (click)="selectComputerClickHandler(false)">
              {{ toComputer()?.name || ('shared:generic.selectComputer' | i18next) }}

              @if (fromComputer() && toComputer() && restoreTo() === restoreToVariants.different) {
                @if (!isOnlineSecondComputer()) {
                  <span class="text-xs text-warning ml-1"> ({{ 'shared:generic.selectOnlineWithWindowsOs' | i18next }}) </span>
                }
                @if (isOnlineSecondComputer() && !isSupportTokenSecondComputer()) {
                  <span class="text-xs text-warning ml-1"> ({{ 'shared:generic.selectWithAgentVersion' | i18next }}) </span>
                }
              }
            </mbs-button>
          } @else {
            <span class="text-xs text-gray-500">{{ 'shared:sidepanel-backup.backupStorages.browseStorage.comingSoonDesc' | i18next }}</span>
          }
        </ng-template>
      </mbs-radio>
    </mbs-form-group>
  </mbs-card-group>
</mbs-card>
